module.exports = __webpack_public_path__ + "img/inge-v9-7.968bb842.png";